import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    shareholderFaqs: [],
    shareholderFaq: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.shareholderFaqs = [];
      state.shareholderFaq = null;
    },
    SET_SHAREHOLDER_FAQS(state, data) {
      state.shareholderFaqs = data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      // state.links = data.links;
      // state.meta = data.meta;
    },
    SET_SHAREHOLDER_FAQ(state, data) {
      state.shareholderFaq = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setShareholderFaq({ commit }, data) {
      commit('SET_SHAREHOLDER_FAQ', data);
    },

    find({ commit, state }) {
      let url = `/shareholder_faqs?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SHAREHOLDER_FAQS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/shareholder_faqs/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_SHAREHOLDER_FAQ', item);
        });
    },

    destroy(_, id) {
      return http(`/shareholder_faqs/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/shareholder_faqs/${id}`, { method: 'PUT', data })
        : http('/shareholder_faqs', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    saveOrder(_, data) {
      const request = http('/shareholder_faqs/order', { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
